import { isAllCardsResult } from "@dashboardApi/apis/engagementAllCards/validators";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { AllCardsParams, AllCardsResponse } from "./types";

export const getAllCards = reactQueryFetcherAdapter(
  cacheKey,
  async (signal, { appGroupId, interaction }: AllCardsParams): Promise<AllCardsResponse> => {
    return await fetch(
      "/engagement/all_cards",
      "GET",
      {
        app_group_id: appGroupId,
        interaction,
      },
      { signal }
    );
  },
  isAllCardsResult
);
